'use strict';require('../../style/css');
require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/tabs/style/css.web.js
// module id = 242
// module chunks = 0